import { render, staticRenderFns } from "./configStockGroup.vue?vue&type=template&id=33d99f7f&scoped=true"
import script from "./configStockGroup.vue?vue&type=script&lang=js"
export * from "./configStockGroup.vue?vue&type=script&lang=js"
import style0 from "./configStockGroup.vue?vue&type=style&index=0&id=33d99f7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d99f7f",
  null
  
)

export default component.exports